import { StyledLinkButton } from '../styledComponents/styledButtons';
import language from './../../utils/language.json';

type ShowMoreButtonProps = {
  onClick?: (...args: any[]) => any;
  showMoreText?: string;
  showLessText?: string;
  variant?: string;
  isExpanded?: boolean;
  testId?: string;
};

export default function ShowMoreButton({
  onClick,
  showMoreText = language.SHOW_MORE,
  showLessText = language.SHOW_LESS,
  variant = 'link',
  testId = 'show-more-button',
  isExpanded,
}: Readonly<ShowMoreButtonProps>) {
  return (
    <StyledLinkButton
      variant={variant}
      color={'blue.600'}
      onClick={onClick}
      data-tracking="show-more-button"
      data-testId={testId}
    >
      {isExpanded ? showLessText : showMoreText}
    </StyledLinkButton>
  );
}
